import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Header from "./components/layout/Header";
import SingleProduct from "./pages/SingleProduct";
import Footer from "./components/layout/Footer";
import Services from "./pages/Services";
import SingleService from "./pages/SingleService";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Awards from "./pages/Awards";
import TopSvg from "./assets/icons/TopSvg";
import { useDispatch, useSelector } from 'react-redux';
import {  getContactData, getContent } from './services/actions/MainAction';
import Loader from './components/common/Loader';
import Lisences from './pages/Lisences';


function App() {
  const [topVisible, setTopVisible] = useState(false);
  const lang_id = useSelector(state=> state.Data.lang_id);
  const langPrefix = useSelector(state=> state.Data.langPrefix);
  const loader = useSelector(state=> state.Data.loader);
  const dispatch = useDispatch()
  useEffect(()=>{
    window.addEventListener("scroll", (e)=>{
      if(window.scrollY>=550){
        setTopVisible(true)
      }else{
        setTopVisible(false)
      }
    })
  },[]);

  useEffect(()=>{
    dispatch(getContent(lang_id));
    dispatch(getContactData(lang_id));
  },[lang_id])

  return (
   <BrowserRouter>
    <Header/>
    <Routes>
      <Route element={ <Home />} path={`/`} />
      <Route element={ <Products />} path={`/measuring-equipment`} />
      <Route element={ <SingleProduct />} path={`/product/:id`} />
      <Route element={ <Services />} path={`/services`} />
      <Route element={ <SingleService />} path={`/service/:id`} />
      <Route element={ <Contact />} path={`/contact`} />
      <Route element={ <About />} path={`/about`} />
      <Route element={ <Awards />} path={`/accreditation`} />
      <Route element={ <Lisences />} path={`/license`} />
    </Routes>
    <Footer /> 
    {
      topVisible?
       <button onClick={()=>window.scrollTo(0,0)} className="fixed bottom-[50px] right-[50px] bg-[--red] w-[50px] h-[50px] rounded-full shadow flex items-center justify-center">
        <TopSvg />
      </button>:null
    }
   {loader? <Loader />:null}
   </BrowserRouter>
  );
}

export default App;
